import React from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import MyPagePanel from '@/components/ui/box/MyPagePanel';
import Paper from '@/components/ui/box/Paper';
import { pageTitles } from '@/constants/pageTitles';
import MyPageTemplate2 from '@/features/mypage/components/MyPageTemplate2';
import ForParentsAppInformation from '@/features/registration/components/ForParentsAppInformation';
import useCurrentUser from '@/hooks/store/useCurrentUser';

import styles from './ParentProfilePageV2.module.scss';
import ParentProfileV2 from './ParentProfileV2';

const ParentProfilePageV2: React.FC = () => {
  const intl = useIntl();
  const [currentParent] = useCurrentUser();

  return (
    currentParent && (
      <MyPageTemplate2>
        <Helmet>
          <title>{pageTitles.mypage}</title>
        </Helmet>
        <Paper>
          <MyPagePanel
            title={intl.formatMessage({ id: 'mypage.profilePage.title' })}
            hidePanelTitleIfMobile
          >
            <ParentProfileV2 parent={currentParent} />
            <div className={styles.ParentProfilePageV2__AppInformation}>
              <ForParentsAppInformation />
            </div>
          </MyPagePanel>
        </Paper>
      </MyPageTemplate2>
    )
  );
};

export default ParentProfilePageV2;
